export const getPaywallsSubscribeUrl = (vanitySlug: string): string =>
  `https://anchor.fm/${vanitySlug}/subscribe`;

export const consumerOffboardingSurveyLink = `https://spotify.co1.qualtrics.com/jfe/form/SV_e8JbbXmwP9KIUl0`;

export const creatorOffboardingSurveyLink = `https://spotify.co1.qualtrics.com/jfe/form/SV_8qdBoSdEYqhLGcK`;
